export default __webpack_public_path__ + "static/media/05_svetl.75f4c631.JPG";